import React, { useEffect, useState } from "react";
import { message } from "antd";
import useIsMobile from "../hooks/useIsMobile";
import { useSelection } from "../SelectionContext";
import { useEcommercePermissions } from "../hooks/useEcommercePermissions";
import ProductsOnlineMobile from "../mobile/ecommerce/ProductsOnlineMobile";
import ProduitsEnLigne from "./ProduitsEnLigne";
import ProductOnlineSettingsModal from "./ProductOnlineSettingsModal";

export default function ResponsiveProduitsEnLigne(props) {
  const mobile = useIsMobile();
  const { selectedCompany, selectedWarehouse } = useSelection();
  const { user } = useEcommercePermissions();
  const context = `${user?.id || ""}:${selectedCompany || ""}:${selectedWarehouse || ""}`;
  const [editing, setEditing] = useState(null);
  const [revision, setRevision] = useState(0);
  const [notices, noticeContext] = message.useMessage();
  useEffect(() => { setEditing((current) => current?.context === context ? current : null); }, [context]);
  const listProps = { ...props, settingsRevision: revision,
    onEditProduct: (product, store) => setEditing({ product, store, context }) };
  // Le formulaire reste monté pendant que les listes desktop/mobile basculent.
  return <>{noticeContext}{mobile ? <ProductsOnlineMobile {...listProps} /> : <ProduitsEnLigne {...listProps} />}
    {editing?.context === context && <ProductOnlineSettingsModal product={editing.product} store={editing.store}
      onClose={() => setEditing(null)} onSaved={() => {
        setEditing(null); setRevision((value) => value + 1); notices.success("Fiche produit mise à jour.");
      }} />}</>;
}
